import apiZervant from '../../utils/apiZervant'
import { PayNowStatus } from './types/payNowStatus'

export const fetchPayNowStatus = async (): Promise<PayNowStatus> => {
  const response = await apiZervant.subscription.get<PayNowStatus>('/paynow')

  return response.data
}

export const connectPayNow = async (stripeAuthCode: string): Promise<PayNowStatus> => {
  const response = await apiZervant.subscription.post<PayNowStatus>('/paynow', { stripeAuthCode })

  return response.data
}

export const disconnectPayNow = async (): Promise<void> => {
  await apiZervant.subscription.delete('/paynow')
}

interface UpdatePayNowActiveStatusParams {
  active: boolean
}

export const updatePayNowActiveStatus = async ({ active }: UpdatePayNowActiveStatusParams): Promise<PayNowStatus> => {
  const response = await apiZervant.subscription.put<PayNowStatus>('/paynow', { active })

  return response.data
}
